<template>
  <div style="width: 100%">
    <v-row align="center" style="max-height: 56px">
      <v-col cols="auto">
        <div class="title text--secondary text-uppercase">
          {{ $t("management.healthHazards.tag.hazards") }}
        </div>
      </v-col>
    </v-row>
    <v-data-table
      :items="tagsWithHazardsAndSearch"
      :headers="headers"
      class="safety-elevation-3 table-striped"
      :loading="loading || $apollo.loading"
      :sort-by="['category', 'healthHazards']"
      :sort-desc="[true, true]"
      :search="search"
      :custom-filter="searchFilter"
      :footer-props="{
        'items-per-page-text': `${$t('employees.footer.itemsPerPage')}`,
        'items-per-page-all-text': `${$t('employees.footer.all')}`,
      }"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          :label="$t('search.title')"
          class="flex-grow-1 pa-3"
          prepend-inner-icon="search"
          single-line
          :background-color="
            $vuetify.theme.themes.light.primary | hexToRgb(0.2)
          "
          solo
          dense
          flat
          hide-details
          clearable
        />
      </template>

      <template v-slot:no-results>{{
        $t("search.noResults", { item: search })
      }}</template>

      <template v-slot:[`item.category`]="{ item }">
        <v-chip small>
          {{ item.category }}
        </v-chip>
      </template>

      <template v-slot:[`item.healthHazards`]="{ item }">
        <div>
          <v-chip
            v-for="healthHazard in item.healthHazards"
            :key="healthHazard.id"
            small
            class="ma-1"
          >
            {{ healthHazard.name }}
          </v-chip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ["healthHazards", "loading", "tags"],
  data() {
    return {
      search: "",
    };
  },
  computed: {
    tagsWithHazardsAndSearch() {
      return (
        this.tags &&
        this.healthHazards &&
        this.tags.map((tag) => {
          const healthHazards = this.getHealthHazardsForTag(tag);
          return {
            ...tag,
            healthHazards: healthHazards,
            search: [
              tag.id,
              tag.name,
              tag.description,
              tag.category,
              ...healthHazards.map((h) => h.name),
            ]
              .join("|")
              .toLowerCase(),
          };
        })
      );
    },
    headers() {
      return [
        {
          text: this.$i18n.t("management.healthHazards.tag.id"),
          value: "id",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("management.healthHazards.tag.name"),
          value: "name",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("management.tag.column.category"),
          value: "category",
          class: "text-uppercase subheading text-truncate",
          sort: (a, b) => this.categorySort(a, b),
        },
        {
          text: this.$i18n.t("management.tag.column.description"),
          value: "description",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("management.healthHazards.tag.relatedHazards"),
          value: "healthHazards",
          class: "text-uppercase subheading text-truncate",
        },
      ];
    },
  },
  methods: {
    categorySort(a, b) {
      const dep = "department";
      if (a == dep && b != dep) {
        return 2;
      }
      if (a != dep && b == dep) {
        return -1;
      }
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    },
    getHealthHazardsForTag(tag) {
      return this.healthHazards.filter((hazard) =>
        hazard.tags.some((hazardTag) => hazardTag.id === tag.id)
      );
    },
    searchFilter(value, search, item) {
      return (
        !search ||
        search
          .toLowerCase()
          .split(" ")
          .every((w) => item.search.includes(w))
      );
    },
  },
};
</script>
